import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API, useAuth } from "../App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");

    (async () => {
      if (!sid) {
        navigate("/", { replace: true });
        return;
      }
      try {
        await axios.post(`${API}/auth/session`, { session_id: sid });
        // Auto-claim referral code if stashed from landing ?ref=
        try {
          const ref = localStorage.getItem("petbond_ref");
          if (ref) {
            try { await axios.post(`${API}/referrals/claim`, { code: ref }); } catch {}
            localStorage.removeItem("petbond_ref");
          }
        } catch {}
        // clear hash
        window.history.replaceState({}, "", "/app");
        await refresh();
        let next = "/app";
        try {
          const intent = localStorage.getItem("petbond_post_signin");
          if (intent) { localStorage.removeItem("petbond_post_signin"); next = intent; }
        } catch {}
        navigate(next, { replace: true });
      } catch (e) {
        console.error("Auth exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-4 border-brand border-t-transparent animate-spin mx-auto mb-4" />
        <div className="font-heading text-xl font-bold">Welcoming you to PetBond…</div>
      </div>
    </div>
  );
}
